document.addEventListener('DOMContentLoaded', function () {
  const screenWidth = window.innerWidth;
  let slidesPerView = 1.3;
  let spaceBetween = 10;
  let centeredSlides = true;
  let freeMode = true;

  if (screenWidth >= 2000) {
    slidesPerView = 6;
    spaceBetween = 30;
    centeredSlides = false;
    freeMode = false;
  } else if (screenWidth >= 1700) {
    slidesPerView = 5;
    spaceBetween = 15;
    centeredSlides = false;
    freeMode = false;
  } else if (screenWidth >= 1300) {
    slidesPerView = 5;
    spaceBetween = 15;
    centeredSlides = false;
    freeMode = false;
  } else if (screenWidth >= 1000) {
    slidesPerView = 4;
    spaceBetween = 15;
    centeredSlides = false;
    freeMode = false;
  } else if (screenWidth >= 640) {
    slidesPerView = 2.5;
    spaceBetween = 20;
  }

  document.querySelectorAll('.swiper-container').forEach(function (container) {
    const numberSlides = container.querySelectorAll('.product-card').length;
    const shouldLoop = numberSlides > slidesPerView;

    new Swiper(container, {
      init: false,
      lazy: true,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      centeredSlides: centeredSlides,
      freeMode: freeMode,
      loop: shouldLoop,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      on: {
        init: function () {
          container.previousElementSibling.style.display = 'none';
          container.querySelector('.swiper-wrapper').style.display = 'flex';
        },
      }
    }).init(); // Inicializa manualmente cada instância do Swiper após a configuração
  });
});
